import 'arrayq';

import { PureConnect, React } from '../../react';
import Button from 'react-toolbox/lib/button/Button';
import Input from 'react-toolbox/lib/input';
import { IBookmark, ICategory } from '../../types';
import CategorySelectPopup from '../categorySelectPopup/input';
import { bookmarksEditor } from './resource';
import { Modal } from '../modal/index';
import FocusLock from 'react-focus-lock';
import cx from './style.less';

const maxBookmarkNameLength = 500;

export default PureConnect(`BookmarksEditModal`)(
    (state) => ({
        creating: bookmarksEditor.selectors.creating(state),
        item: bookmarksEditor.selectors.item(state),
        updating: bookmarksEditor.selectors.updating(state),
    }),
    (dispatch) => ({
        cancel: () => dispatch(bookmarksEditor.actions.RESET({ })),
        cancelCreating: () => dispatch(bookmarksEditor.actions.CREATE_CANCEL({ })),
        cancelUpdating: () => dispatch(bookmarksEditor.actions.UPDATE_CANCEL({ })),
        change: (item: IBookmark | any) => dispatch(bookmarksEditor.actions.APPLY({ item })),
        saveCreating: (item: IBookmark) => dispatch(bookmarksEditor.actions.CREATE_CONTINUE({ item })),
        saveUpdating: (item: IBookmark) => dispatch(bookmarksEditor.actions.UPDATE_CONTINUE({ item })),
    }),
    ({ creating, updating, item, change, saveCreating, cancelCreating, saveUpdating, cancelUpdating }) => {
        const onCancel = creating ? cancelCreating : cancelUpdating;
        const onSave = creating ? () => saveCreating(item) : () => saveUpdating(item);

        return (
            <Modal onEscKeyDown={onCancel} 
                  visible={(creating || updating)} 
                  type="center2nd" 
                  backdrop={true}
                  header={<div className={cx('title')}>{updating ? 'Favoriet bewerken' : 'Favoriet toevoegen'}</div>}>
                    <div className={cx(!(creating || updating) ? 'wcag-invisible' : '', 'fields-container')}  aria-hidden={!(creating || updating)} aria-labelledby= {updating ? 'Bewerk favoriet' : 'Voeg favoriet toe'}>
                        <FocusLock disabled={!(creating || updating)}>               
                            <Input
                                type="text"
                                label="Typ hier uw notitie"
                                name="name"
                                value={item.name} maxLength={maxBookmarkNameLength}
                                multiline
                                onChange={(value: string) => change({ name: value })}
                                floating />
                            <CategorySelectPopup
                                categoryId={item.categoryId}
                                onChange={(c: ICategory) => { change({ categoryId: c ? c.id : undefined }); }}
                                onAbort={() => {}}
                                mode="edit"
                                label="Categorie" />
                            <div className={cx('button-aria', !(creating || updating)? 'wcag-invisible' : '' )}>    
                                <Button onClick={onCancel}>Annuleren</Button>
                                <Button onClick={onSave}>Opslaan</Button>                    
                            </div>       
                        </FocusLock>
                    </div>
                </Modal>        

        );
    });



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/bookmarks/editModal.tsx